module.exports = __webpack_public_path__ + "mf.svg?d7647f6c1ba0431e6e97e6eefd7ec479";